/** sessionStorage keys for the guest WhatsApp-order post-login intent flow. */
export const SESSION_PENDING_WA_INTENT = 'nine_pending_wa_intent';
export const SESSION_PENDING_WA_ADDRESS = 'nine_pending_wa_address';

/**
 * Curator photo-analysis sessions (see ImageAnalyzePersistence).
 *
 * The `.v1` suffix is part of the key on purpose: the persisted shape carries a
 * schema version, and bumping the key alongside it is what guarantees an old
 * blob from a previous build can never be read back by a newer one, even if the
 * version check inside were ever loosened.
 */
export const SESSION_IMAGE_ANALYZE = 'nine.imageAnalyze.v1';

/**
 * Admin Onboarding Calendar → Targets: ids of people the admin unticked, per
 * role (localStorage, so the choice survives reloads). Stores a plain string[].
 */
export const targetsHiddenKey = (role: string): string => `nine.targetsHidden.${role}.v1`;

/**
 * Anonymous (logged-out) business ratings. localStorage, so a visitor keeps the same identity
 * across reloads: the random device UUID sent as X-Device-Id, and a { [businessId]: ratingId }
 * map of the anonymous ratings this browser posted (so "your review" edit/delete still works).
 */
export const LS_ANON_DEVICE_ID = 'nine.anonDeviceId.v1';
export const LS_ANON_RATINGS = 'nine.anonRatings.v1';

/** Catalogue import review: the first-run tip strip was dismissed (localStorage, "1"). */
export const LS_CATALOG_IMPORT_REVIEW_TIP = 'nine.catalogImport.review.tipDismissed';

/** Turbo switch position per business (cleared on logout). */
export const LS_TURBO = 'nine.turbo.v1';
